import { LoadingButton } from '@mui/lab';
import {
  Box,
  Card,
  DialogContent,
  DialogContentText,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  styled
} from '@mui/material';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';

import DialogTitle from '@mui/material/DialogTitle';
import { useEffect } from 'react';
import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getSingleIncomeEntry } from '../helper/getSingleOrder';
import dayjs from 'dayjs';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { updateIncomeEntry } from 'app/contexts/reducers/transaction/incomeEntrySlice';
import { getIncomeTypeData } from 'app/contexts/reducers/incomeType/incomeTypeSlice';
import { convertYearId } from 'app/utils/convertId';
const StyledCard = styled(Card)(({ theme }) => ({
  display: 'flex',
  flexWrap: 'wrap',
  alignItems: 'center',
  justifyContent: 'space-between',
  padding: '24px !important',
  background: theme.palette.background.paper,
  [theme.breakpoints.down('sm')]: { padding: '16px !important' }
}));
const ContentBox = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexWrap: 'wrap',
  alignItems: 'center',
  justifyContent: 'flex-start',
  '& small': { color: theme.palette.text.secondary },
  '& .icon': { opacity: 0.6, fontSize: '44px', color: theme.palette.primary.main }
}));
export default function UpdateIncomeEntryDialog({
  open,
  onClose,
  updateEntryId,
  setApiCall,
  handleClickSuccess,
  setError,
  handleClickError
}) {
  const dispatch = useDispatch();
  const { isIncomeTypeSuccess, incomeTypeData } = useSelector((state) => state.incomeType);

  const { isAllIncomeEntriesSuccess, allIncomeEntriesData } = useSelector(
    (state) => state.incomeEntry
  );
  const { bookMasterData } = useSelector((state) => state.bookMaster);

  const yearData = bookMasterData?.data?.data || [];
  const [updateValue, setUpdateValue] = useState({
    incomeType: '',
    amount: '',
    paymentType: '',
    bookNumber: '',
    bookId: null,
    date: '',
    remark: ''
  });
  const [incomeType, setIncomeType] = useState([]);

  const [loading, setLoading] = useState(false);
  useEffect(() => {
    dispatch(getIncomeTypeData());
  }, [dispatch]);
  useEffect(() => {
    if (allIncomeEntriesData) {
      getSingleIncomeEntry(allIncomeEntriesData.data.data, updateEntryId).then(
        (incomeEntryDetails) => {
          incomeEntryDetails &&
            setUpdateValue({
              paymentType: incomeEntryDetails.payment_type,
              incomeType: incomeEntryDetails.income_type,
              bookNumber: incomeEntryDetails.book_number,
              bookId: incomeEntryDetails.book_id,
              date: dayjs(incomeEntryDetails.date),
              amount: incomeEntryDetails.amount,
              remark: incomeEntryDetails.remark
            });
        }
      );
    }
    // eslint-disable-next-line
  }, [updateEntryId, isAllIncomeEntriesSuccess, allIncomeEntriesData, open]);
  useEffect(() => {
    if (isIncomeTypeSuccess) {
      if (Number(incomeTypeData.data.code) === 200) {
        setIncomeType(incomeTypeData.data.data);
      } else {
        setIncomeType([]);
      }
    }
  }, [isIncomeTypeSuccess, incomeTypeData]);
  async function handleUpdate() {
    try {
      if (
        updateValue.incomeType &&
        updateValue.incomeType.length > 0 &&
        updateValue.amount &&
        Number(updateValue.amount) > 0 &&
        updateValue.paymentType &&
        updateValue.paymentType.length > 0 &&
        updateValue.bookId
      ) {
        const incomeEntryDetails = { ...updateValue };
        Object.keys(incomeEntryDetails).forEach((key) => {
          if (incomeEntryDetails[key] === '') {
            delete incomeEntryDetails[key];
          }
          // if (key === 'date') {
          //   incomeEntryDetails[key] = dayjs(incomeEntryDetails[key]).format('YYYY-MM-DD');
          // }
        });

        const responseValue = await dispatch(
          updateIncomeEntry({ entryId: updateEntryId, incomeEntryDetails })
        );
        if (!responseValue.hasOwnProperty('error')) {
          onClose();
          handleClickSuccess('Income-Entry Updated successfully!!');
          setApiCall((prev) => !prev);
          setLoading(false);
        } else {
          setApiCall((prev) => !prev);
          throw responseValue;
        }
      } else {
        if (!updateValue.bookId) {
          handleClickError();
          setError({ payload: 'Financial year not configured in Book Master. Please contact Admin.' });
          setLoading(false);
          return;
        }
        handleClickError();
        setError({ payload: 'Please Fill Mandatory Data!' });
        setLoading(false);
      }
    } catch (e) {
      handleClickError();
      setError(e);
      setLoading(false);
    }
  }

  const handleIncomeTypeSelect = async (e) => {
    setUpdateValue({ ...updateValue, incomeType: e.target.value });
  };
  const handleBookNameSelect = async (e) => {
    const yearId = convertYearId(yearData, e.target.value);
    if (yearId) {
      setUpdateValue({ ...updateValue, bookNumber: e.target.value, bookId: yearId.id });
    }
  };
  const handlePaymentTypeSelect = async (e) => {
    setUpdateValue({ ...updateValue, paymentType: e.target.value });
  };

  const PaymentType = [
    {
      name: 'CASH'
    },
    {
      name: 'BANK'
    }
  ];

  return (
    <Box>
      <Dialog open={open} onClose={onClose} aria-labelledby='form-dialog-title'>
        <DialogTitle id='form-dialog-title'>Update Income-Entry</DialogTitle>
        <DialogContent>
          <DialogContentText sx={{ mb: '10px' }}>
            You can Update Your Income Entry Details From Here!{' '}
          </DialogContentText>

          <Grid container spacing={3} sx={{ mb: '24px' }}>
            <Grid item xs={12} md={12}>
              <StyledCard elevation={6}>
                <Grid container>
                  <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                    <InputLabel sx={{ fontSize: '10px' }} id='incomeType'>
                      Income Type
                    </InputLabel>
                    <Select
                      size='small'
                      sx={{ my: 1, width: '80%' }}
                      variant='standard'
                      labelId='incomeType'
                      value={updateValue.incomeType}
                      onChange={handleIncomeTypeSelect}
                    >
                      {incomeType &&
                        incomeType.map((data, index) => (
                          <MenuItem value={data.income_type} key={index} id={index}>
                            {data.income_type}
                          </MenuItem>
                        ))}
                    </Select>
                    <ContentBox>
                      <TextField
                        id='amount'
                        type='number'
                        margin='dense'
                        size='small'
                        label='Amount'
                        InputLabelProps={{ shrink: true }}
                        sx={{ my: 1, width: '80%' }}
                        variant='standard'
                        value={updateValue.amount == null ? 'null' : updateValue.amount}
                        onChange={(e) => {
                          setUpdateValue({ ...updateValue, amount: e.target.value });
                        }}
                      />
                    </ContentBox>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <DatePicker
                        sx={{ width: '80%', my: 1 }}
                        label='Date'
                        format='DD/MM/YYYY'
                        value={updateValue.date}
                        onChange={(newValue) => {
                          setUpdateValue({ ...updateValue, date: newValue });
                        }}
                        slotProps={{
                          textField: {
                            variant: 'standard'
                          }
                        }}
                      />
                    </LocalizationProvider>
                  </Grid>
                  <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                    <InputLabel sx={{ fontSize: '10px' }} required id='bookNumber'>
                      Book Number
                    </InputLabel>

                    <Select
                      size='small'
                      sx={{ width: '80%', my: 1 }}
                      variant='standard'
                      labelId='customerReceiptBookNumber'
                      value={updateValue.bookNumber}
                      onChange={handleBookNameSelect}
                    >
                      {yearData.map((data, index) => (
                        <MenuItem value={data.name} key={index} id={index}>
                          {data.name}
                        </MenuItem>
                      ))}
                    </Select>
                    <InputLabel sx={{ fontSize: '10px' }} id='paymentType'>
                      Payment Type
                    </InputLabel>
                    <Select
                      size='small'
                      sx={{ my: 1, width: '80%' }}
                      variant='standard'
                      labelId='diamondType'
                      value={updateValue.paymentType}
                      disabled={updateValue.paymentType.toLowerCase() === 'bank'}
                      onChange={handlePaymentTypeSelect}
                    >
                      {PaymentType.map((data, index) => (
                        <MenuItem value={data.name} key={index} id={index}>
                          {data.name}
                        </MenuItem>
                      ))}
                    </Select>

                    <ContentBox>
                      <TextField
                        multiline
                        maxRows={4}
                        id='remark'
                        type='text'
                        margin='dense'
                        size='small'
                        label='Remark'
                        InputLabelProps={{ shrink: true }}
                        sx={{ my: 1, width: '80%' }}
                        variant='standard'
                        value={updateValue.remark}
                        onChange={(e) => {
                          setUpdateValue({ ...updateValue, remark: e.target.value });
                        }}
                      />
                    </ContentBox>
                  </Grid>
                </Grid>
              </StyledCard>
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button variant='standard' color='secondary' onClick={onClose}>
            Cancel
          </Button>
          <LoadingButton
            onClick={handleUpdate}
            color='primary'
            loading={loading}
            variant='contained'
            sx={{ my: 2 }}
          >
            Update Income Entry
          </LoadingButton>
        </DialogActions>
      </Dialog>
    </Box>
  );
}
